import { render, staticRenderFns } from "./SupplierDetail.vue?vue&type=template&id=b291ed00&scoped=true&"
import script from "./SupplierDetail.vue?vue&type=script&lang=js&"
export * from "./SupplierDetail.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDetail.vue?vue&type=style&index=0&id=b291ed00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b291ed00",
  null
  
)

export default component.exports